import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NzIconService } from 'ng-zorro-antd/icon';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  private loadedIcons = new Set<string>();

  constructor(private iconSrv: NzIconService, private http: HttpClient) { }

  getIcon(link: string, name: string) {
    if(this.loadedIcons.has(name)) return;
    this.http.get(link, { responseType: 'text' }).subscribe(svg => {
      this.iconSrv.addIconLiteral(name, svg);
    })
  }

  registerIcons(icons: {name: string; link: string }[]) {
    icons.forEach(icon => this.getIcon(icon.link, icon.name))
  }
}
